import { render, staticRenderFns } from "./IssuedFinancialDashboard.vue?vue&type=template&id=20b538c2&scoped=true"
import script from "./IssuedFinancialDashboard.vue?vue&type=script&lang=js"
export * from "./IssuedFinancialDashboard.vue?vue&type=script&lang=js"
import style0 from "./IssuedFinancialDashboard.vue?vue&type=style&index=0&id=20b538c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b538c2",
  null
  
)

export default component.exports